/**
 * Brand constants (D73). Change the visible name here and every app, page title, email and
 * wordmark picks it up. "CUSTOS" stays the internal codename.
 */
export const APP_NAME = "Aurix Wallet";
/** Short form for the wordmark and phrases like "Aurix support" or "your Aurix Account". */
export const APP_SHORT_NAME = "Aurix";
export const APP_TAGLINE = "Your crypto, in one place";
/**
 * Hidden technical id for service names, folders, storage keys, cookies and the JWT issuer.
 * FROZEN at "custos" (D73): it is deliberately NOT derived from APP_NAME, so a rename never
 * logs users out or hides vaults already stored in a browser.
 */
export const APP_ID = "custos";
//# sourceMappingURL=brand.js.map